import React, { createContext, useContext, useState } from 'react';

interface ApiServerHelpContextType {
  isOpen: boolean;
  data: any;
  openPortal: (data: any) => void;
  closePortal: () => void;
}

const ApiServerHelpContext = createContext<ApiServerHelpContextType | undefined>({
  isOpen: false,
  data: null,
  openPortal: () => {},
  closePortal: () => {},
});

export const ApiServerHelpProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<any>(null);

  const openPortal = (portalData: any) => {
    setData(portalData);
    setIsOpen(true);
  };

  const closePortal = () => {
    setIsOpen(false);
    setData(null);
  };

  return (
    <ApiServerHelpContext.Provider value={{ isOpen, data, openPortal, closePortal }}>
      {children}
    </ApiServerHelpContext.Provider>
  );
};

export const useApiServerHelp = () => {
  const context = useContext(ApiServerHelpContext);
  if (!context) {
    throw new Error('useApiServerHelp must be used within ApiServerHelpProvider');
  }
  return context;
};
